import React, { useState } from 'react';
import { css } from '@emotion/react';

interface IMenuProps {
  open: boolean;
  isAuthenticated: boolean;
}

interface ITabNames {
  info: string;
  requestcase: string;
  bookmark: string;
  highlight: string;
  history: string;
}

const baseUrl = 'https://legalengine.co.kr';

export const Menu = ({ open, isAuthenticated }: IMenuProps) => {
  const [tabNames, setTabNames] = useState<ITabNames>({
    info: '회원 정보',
    requestcase: '내가 요청한 판례',
    bookmark: '북마크',
    highlight: '하이라이트',
    history: '히스토리',
  });

  const RenderIsAuth = () => {
    return (
      <div
        css={css`
          @media (max-width: 992px) {
            position: relative;
            top: 50px;
            font-size: 18px;
            line-height: 40px;
            border-top: 0.5px solid #c4c4c4;
            padding: 1rem 0 1rem 0;
          }
        `}
      >
        {Object.entries(tabNames).map((e, idx) => {
          return (
            <a
              key={e[0]}
              css={css`
                @media (max-width: 992px) {
                  text-align: left;
                  text-decoration: none;
                }
              `}
              href={`${baseUrl}/user/profile/${e[0]}`}
            >
              <div
                css={css`
                  @media (max-width: 992px) {
                    border: none;
                    background-color: white;
                    padding: 0.5rem 0 0.5rem 2rem;
                    color: #424242;
                    font-weight: 500;
                  }
                `}
              >
                {e[1]}
              </div>
            </a>
          );
        })}
      </div>
    );
  };

  return (
    <div
      css={css`
        display: none;
        @media (max-width: 992px) {
          display: block;
        }
      `}
    >
      <div
        css={css`
          @media (max-width: 992px) {
            position: fixed;
            background-color: white;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            z-index: 2000;
          }
        `}
        style={{
          display: open ? 'block' : 'none',
        }}
      >
        {isAuthenticated ? (
          <RenderIsAuth />
        ) : (
          <div
            css={css`
              @media (max-width: 992px) {
                position: relative;
                display: flex;
                top: 50px;
                font-size: 18px;
                line-height: 26px;
                font-weight: 500;
                text-align: center;
                width: 100%;
                height: 55px;
                border-top: 0.5px solid #c4c4c4;
                a {
                  text-decoration: none;
                }
              }
            `}
          >
            <a href={`${baseUrl}/user/login`}>
              <div
                css={css`
                  @media (max-width: 992px) {
                    width: 50vw;
                    position: relative;
                    line-height: 55px;
                    background-color: white;
                    color: #424242;
                  }
                `}
              >
                {`로그인`}
              </div>
            </a>
            <a href={`${baseUrl}/user/signup`}>
              <div
                css={css`
                  @media (max-width: 992px) {
                    width: 50vw;
                    position: relative;
                    line-height: 55px;
                    background-color: white;
                    color: #424242;
                    border-left: 0.5px solid #c4c4c4;
                  }
                `}
              >
                {`회원가입`}
              </div>
            </a>
          </div>
        )}
        <div
          css={css`
            @media (max-width: 992px) {
              position: relative;
              top: 50px;
              font-size: 18px;
              line-height: 40px;
              font-weight: 500;
              border-top: 0.5px solid #c4c4c4;
              padding: 1rem 0 1rem 0;
              a {
                text-decoration: none;
              }
            }
          `}
        >
          <a
            css={css`
              display: flex;
              flex-flow: row nowrap;
              justify-items: center;
              align-self: center;
            `}
            href='/crimesearch'
          >
            <div
              css={css`
            @media (max-width: 992px) {
              padding: 0.5rem 0 0.5rem 2rem;
              color: #424242;
              text-align: left;
              padding-right: 0.2rem;
            `}
            >
              {`무죄판결 검색`}
            </div>
            <div
              css={css`
                position: relative;
                bottom: 10px;
                align-self: center;
                font-size: 12px;
                color: rgb(229, 25, 42);
                font-weight: 600;
                padding-right: 0.5rem;
              `}
            >
              {`new`}
            </div>
          </a>
          {/*<a href={`${baseUrl}/requestcase`}>
            <div
              css={css`
                @media (max-width: 992px) {
                  padding: 0.5rem 0 0.5rem 2rem;
                  color: #424242;
                  text-align: left;
                }
              `}
            >
              {`판례 요청`}
            </div>
          </a>*/}
          <a href={`${baseUrl}/posts`}>
            <div
              css={css`
                @media (max-width: 992px) {
                  padding: 0.5rem 0 0.5rem 2rem;
                  color: #424242;
                  text-align: left;
                }
              `}
            >
              {`포스트`}
            </div>
          </a>
          <a href={`${baseUrl}/translator`}>
            <div
              css={css`
                @media (max-width: 992px) {
                  padding: 0.5rem 0 0.5rem 2rem;
                  color: #424242;
                  text-align: left;
                }
              `}
            >
              {`법률 번역`}
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};
